/* BCS master design system helpers (Oct 2026).
   1. Product page: tag the Essential Upsell "Frequently bought together" block and move it below the delivery lines.
   2. Product page: hide the "No reviews" stars until a product has a review.
   3. Mobile header: after scrolling, collapse the search row to a search icon (tap it to bring the search back).
   4. Sticky add-to-cart bar follows the selected variant; floating buttons step aside for drawers (QA fixes, Oct 2026). */
(function () {
  'use strict';

  function tidyProductPage() {
    var form = document.querySelector('.product-form');
    var buybox = document.querySelector('.pdp__buybox-inner');
    if (!form || !buybox) return;

    // 1. Delivery / collect / secure lines: move our own strip up into the form, straight after the buy buttons,
    //    so the upsell app's block (which it re-mounts whenever it likes, so we never move it) ends up below them.
    var usp = buybox.querySelector('.pdp-usp-strip');
    var buy = form.querySelector('.product-info__block-item--buy-buttons');
    if (usp && buy && usp.parentNode !== form) {
      form.insertBefore(usp, buy.nextSibling);
    }
    // Tag the app's block so the CSS can calm it down (class only; re-applied if the app re-renders).
    var blocks = form.querySelectorAll(':scope > div');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.classList.contains('product-info__block-item') || b.classList.contains('bcs-fbt')) continue;
      if (/frequently bought together/i.test(b.textContent || '')) { b.classList.add('bcs-fbt'); break; }
    }

    // 2. "No reviews" badge
    var badge = document.querySelector('.product-meta__reviews-badge');
    if (badge && /no reviews/i.test(badge.textContent || '')) badge.classList.add('bcs-no-reviews');
  }

  function setupMobileHeader() {
    var actions = document.querySelector('.bcs-header__actions-group');
    var search = document.querySelector('.bcs-header__mobile-search');
    if (!actions || !search) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bcs-header__scroll-search';
    btn.setAttribute('aria-label', 'Search');
    btn.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>';
    btn.addEventListener('click', function () {
      document.documentElement.classList.remove('bcs-scrolled');
      var input = search.querySelector('input[type="search"], input[type="text"], input');
      if (input) { try { input.focus(); } catch (e) {} }
      locked = true; setTimeout(function () { locked = false; }, 1500);
    });
    actions.insertBefore(btn, actions.firstChild);

    var locked = false, ticking = false;
    function update() {
      ticking = false;
      if (locked) return;
      var scrolled = window.scrollY > 80;
      document.documentElement.classList.toggle('bcs-scrolled', scrolled);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  // 4. Collection / search pagination: the base theme scrolls back to the top of the grid using
  //    --header-is-sticky / --header-height; the BCS header never sets the first one, so it computed
  //    NaN and the shopper stayed at the bottom of the page. Set the variable and scroll ourselves.
  function setupPaginationScroll() {
    var root = document.documentElement;
    if (!getComputedStyle(root).getPropertyValue('--header-is-sticky').trim()) root.style.setProperty('--header-is-sticky', '1');
    var pending = false;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.pagination [data-page]');
      if (a) pending = true;
    }, true);
    document.addEventListener('theme:loading:end', function () {
      if (!pending) return;
      pending = false;
      var grid = document.querySelector('.collection__dynamic-part, .collection, .search__results, main');
      if (!grid) return;
      var header = document.querySelector('.bcs-header');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
      var top = grid.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    });
  }

  // 5. Collection teaser: the section flattens the whole description (FAQ headings included) into one
  //    run-on line. Show the first real paragraph instead; the full description still sits at the bottom.
  function tidyCollectionTeaser() {
    var teaser = document.querySelector('.collection__description-teaser-text');
    var full = document.getElementById('collection-full-description');
    if (!teaser || !full) return;
    var p = full.querySelector('p');
    var text = p ? (p.textContent || '').trim() : '';
    if (!text) return;
    var words = text.split(/\s+/);
    if (words.length > 60) text = words.slice(0, 60).join(' ') + '...';
    teaser.textContent = text;

    // "Show more" used to jump to the copy at the foot of the page; expand in place instead.
    var link = document.querySelector('.collection__description-readmore');
    var rte = full.querySelector('.rte') || full;
    if (!link) return;
    var short = text, open = false;
    var label = link.childNodes[0];
    link.setAttribute('role', 'button');
    document.addEventListener('click', function (e) {
      if (!e.target.closest || e.target.closest('.collection__description-readmore') !== link) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open = !open;
      if (open) {
        teaser.innerHTML = rte.innerHTML;
        teaser.querySelectorAll('details').forEach(function (d) { d.setAttribute('open', ''); });
        teaser.classList.add('is-expanded');
        full.classList.add('bcs-hidden');
      } else {
        teaser.textContent = short;
        teaser.classList.remove('is-expanded');
        full.classList.remove('bcs-hidden');
      }
      if (label && label.nodeType === 3) label.nodeValue = open ? ' Show less ' : ' Show more ';
      link.classList.toggle('is-open', open);
    }, true);
  }

  // 6. Base-theme product cards: the sale badge sits outside the image box, so it lands on the price.
  //    Move it into the image box (bottom-left, like the homepage cards).
  function tidyProductCards() {
    document.querySelectorAll('.product-item').forEach(function (item) {
      var labels = item.querySelector(':scope > .product-item__label-list');
      var wrap = item.querySelector('.product-item__image-wrapper');
      if (labels && wrap) { wrap.style.position = 'relative'; wrap.appendChild(labels); }
    });
  }


  // QA fixes (21 Oct 2026)
  // a) Sticky add-to-cart bar: show the selected variant's price, "was" price and image (the section prints the product-level
  //    min price and max compare price, e.g. "£350" crossed out on the 1L Canna Boost).
  function setupStickyCtaVariant() {
    var bar = document.querySelector('[data-pdp-sticky-cta]');
    var form = document.querySelector('form[id^="product-form-main"]');
    if (!bar || !form) return;
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return;
    var fmt = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    function money(cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.'));
    }
    var priceEl = bar.querySelector('.pdp-sticky-cta__price');
    var thumb = bar.querySelector('.pdp-sticky-cta__thumb');
    var btn = bar.querySelector('.pdp-sticky-cta__button');
    var btnLabel = btn ? btn.textContent.trim() : '';
    var variants = null, current = null;
    function selectedId() {
      var sel = form.querySelector('[name="id"]');
      return sel ? String(sel.value) : null;
    }
    function render() {
      if (!variants) return;
      var id = selectedId();
      if (!id || id === current) return;
      var v = variants[id];
      if (!v) return;
      current = id;
      if (priceEl) {
        var html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) html += '<s>' + money(v.compare_at_price) + '</s>';
        html += '<strong>' + money(v.price) + '</strong>';
        priceEl.innerHTML = html;
      }
      if (thumb && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src.replace(/^https?:/, '');
        thumb.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btnLabel : ((window.languages && window.languages.productFormSoldOut) || 'Sold out');
      }
    }
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        variants = {};
        p.variants.forEach(function (v) { variants[String(v.id)] = v; });
        render();
        document.addEventListener('variant:changed', function () { setTimeout(render, 30); });
        form.addEventListener('change', function () { setTimeout(render, 30); });
        setInterval(render, 500);
      })
      .catch(function () {});
  }

  // b) Keep floating things out of the way: hide the WhatsApp bubble and the sticky bar while a drawer (filters, basket)
  //    is open, and lift the WhatsApp bubble above the sticky bar when that bar is showing.
  function setupOverlapGuards() {
    var root = document.documentElement;
    // Filter panel and other side drawers open above the sticky header (header is 1000, Warehouse drawers were 5),
    // floating buttons hide while a drawer or the basket is open, and WhatsApp sits above the sticky bar.
    if (!document.getElementById('bcs-overlap-css')) {
      var st = document.createElement('style');
      st.id = 'bcs-overlap-css';
      st.textContent = ".drawer[aria-hidden=\"false\"]{z-index:1003!important}html.bcs-overlay-open .wa-float,html.bcs-overlay-open .pdp-sticky-cta,html.bcs-overlay-open #smile-ui-lite-launcher-frame-container{opacity:0!important;visibility:hidden!important;pointer-events:none!important}html.bcs-sticky-on .wa-float{bottom:calc(var(--bcs-sticky-h,72px) + 12px)!important;transition:bottom .25s ease,opacity .2s ease}html.bcs-sticky-on #smile-ui-lite-launcher-frame-container{bottom:calc(var(--bcs-sticky-h,72px) + 80px)!important}";
      document.head.appendChild(st);
    }
    var pending = false;
    function sync() {
      pending = false;
      var open = !!document.querySelector('.drawer[aria-hidden="false"], #mini-cart[aria-hidden="false"]');
      root.classList.toggle('bcs-overlay-open', open);
      var bar = document.querySelector('[data-pdp-sticky-cta]');
      var on = !!(bar && !bar.hasAttribute('hidden') && window.innerWidth <= 900);
      root.classList.toggle('bcs-sticky-on', on);
      if (on) root.style.setProperty('--bcs-sticky-h', bar.offsetHeight + 'px');
    }
    function schedule() { if (!pending) { pending = true; window.requestAnimationFrame(sync); } }
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-hidden', 'hidden'] });
    }
    window.addEventListener('resize', schedule);
    sync();
  }

  function init() {
    try { setupMobileHeader(); } catch (e) {}
    try { tidyProductCards(); document.addEventListener('theme:loading:end', tidyProductCards); } catch (e) {}
    try { setupPaginationScroll(); } catch (e) {}
    try { tidyCollectionTeaser(); } catch (e) {}
    try { setupOverlapGuards(); } catch (e) {}
    try { setupStickyCtaVariant(); } catch (e) {}
    if (document.body.classList.contains('template-product')) {
      // The upsell app injects late and the buybox can re-render on variant change, so keep watching.
      var apply = function () { try { tidyProductPage(); } catch (e) {} };
      apply();
      var tries = 0;
      var t = setInterval(function () { tries++; apply(); if (tries > 120) clearInterval(t); }, 500);
      if (window.MutationObserver) {
        var mo = new MutationObserver(function () { apply(); });
        mo.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      }
      document.addEventListener('variant:changed', function () { setTimeout(apply, 300); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
